import React from "react";
import CustomersAlsoViewedCarousel from "../CustomersAlsoViewedCarousel";
import OtherProductsInThisLineCarousel from "../OtherProductsInThisLineCarousel";
import DescriptionSection from "../DescriptionSection";
import { ProductDetailPageResult } from "../ProductDetailPageResult";
import { defaultUserObject } from "~/common/Store/rootReducer";
import { CarouselPlacement } from "../Carousel/getCarouselPlacement";

interface MainColumnSectionProps {
  activeTemplate: ProductDetailPageResult;
  carouselPlacement: CarouselPlacement;
  isExpandedDescriptionTemplate: boolean;
  mounted: boolean;
  minimalPageVersion: boolean | undefined;
  setExpandedDescriptionOffABTest?: React.Dispatch<
    React.SetStateAction<boolean>
  >;
}
export const MainColumnSection = ({
  activeTemplate,
  carouselPlacement,
  isExpandedDescriptionTemplate,
  mounted,
  minimalPageVersion,
  setExpandedDescriptionOffABTest,
}: MainColumnSectionProps) => {
  const {
    itemNumber,
    customersAlsoViewedCarouselItems,
    otherProductsFromThisLine,
    otherProductsCarouselPromotion,
  } = activeTemplate;

  return (
    <div className="main-col">
      {carouselPlacement.showCAVCarousel && (
        <CustomersAlsoViewedCarousel
          key={`customersAlsoViewedCarousel-${itemNumber}`}
          carouselItems={customersAlsoViewedCarouselItems}
          itemNumber={itemNumber}
        />
      )}
      {carouselPlacement.showOPFTLCarouselAboveDescription && (
        <OtherProductsInThisLineCarousel
          key={`otherProductsCarousel-${itemNumber}`}
          carouselItems={otherProductsFromThisLine}
          otherProductsCarouselPromotionMember={otherProductsCarouselPromotion}
        />
      )}
      {!minimalPageVersion && (
        <DescriptionSection
          isExpandedDescriptionTemplate={isExpandedDescriptionTemplate}
          activeTemplate={activeTemplate}
          user={defaultUserObject}
          setExpandedDescriptionOffABTest={setExpandedDescriptionOffABTest}
          mounted={mounted}
        />
      )}
    </div>
  );
};
